export default __webpack_public_path__ + "static/media/fishing.15e46e57.svg";